import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import enums from 'util/enums';

export const DEVICE_TAGS = {
  LIST: 'DEVICE_LIST'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [DEVICE_TAGS.LIST]
});

export const deviceApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listDevices: build.query({
      async queryFn(args) {
        const { skip = 0, pageSize = 25 } = args || {};

        const body = {
          MaxResults: pageSize,
          Skip: skip,
          OrderBy: 'LastSeen',
          OrderDirection: 'desc'
        };

        try {
          const res = await api.Enumeration(
            enums.ENUMERATION_TYPES.DEVICE,
            body
          );
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      keepUnusedDataFor: 60,
      providesTags: [{ type: DEVICE_TAGS.LIST, id: 'LIST' }]
    })
  })
});

export const { useListDevicesQuery } = deviceApi;
